module.exports = __webpack_public_path__ + "img/1.b06915b7.jpg";